import React from 'react';
import { StaticQuery, graphql } from 'gatsby';
import Img from 'gatsby-image';
import BgImage from './BgImage';
import { StNonProcessedImage } from './style.css';

const Image = (props) => (
	<StaticQuery
		query={graphql`
			query {
				images: allFile {
					edges {
						node {
							relativePath
							name
							publicURL
							url
							childImageSharp {
								normal: sizes(maxWidth: 1200) {
									...GatsbyImageSharpSizes
								}
							}
						}
					}
				}
			}
		`}
		render={(data) => {
			const image = data.images.edges.find((n) => {
				if (props.filename) {
					return n.node.relativePath.includes(props.filename)
				}
				if (props.originalurl) {
					console.log(n.node, props.originalurl)
					return n.node.url === props.originalurl
				}
			});

			if (!image) {
				return null;
			}

			if (!image.node.childImageSharp && image.node.publicURL) {
				return (
					<StNonProcessedImage>
						<img src={image.node.publicURL} alt="" />
					</StNonProcessedImage>
				);
			}

			const imageSizes = (imgtype) => {
				switch (imgtype) {
					default:
						return image.node.childImageSharp.normal;
				}
			};

			if (props.bg) {
				return <BgImage alt={props.alt} sizes={imageSizes(props.type)} />;
			}
			return <Img alt={props.alt} sizes={imageSizes(props.type)} />;
		}}
	/>
);

export default Image;
